export default "<p [innerHTML]=\"zeile1\"></p>\n<p [innerHTML]=\"zeile2\"></p>\n"